<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Filtrar por</p>
    <v-autocomplete
      class="form-panel__field"
      outlined
      dense
      label="Criador"
      v-model="filter.person"
      :items="computedCreators"
      item-text="name"
      item-value="id"
      return-object
      @change="$emit('get-farms', filter.person)"
    ></v-autocomplete>
    <div class="form-panel__field" :class="filter.animals && filter.animals.length > 6 ? 'resize-autocomplete' : ''"> 
      <v-autocomplete
          outlined
          dense
          label="Propriedade"
          :items="farms"
          item-text="name"
          item-value="id"
          v-model="filter.farms"
          multiple
          no-data-text="Nenhum Resultado"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllFarms">
              <v-list-item-action>
                <v-icon
                  :color="
                    filter.farms.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
    </div> 
    <div class="form-panel__field">
      <date-picker
        label="Data Inicial"
        dense
        :binding.sync="filter.date"
        :readOnly="false"
      ></date-picker>
    </div>
    <div class="form-panel__field">
      <date-picker
        label="Data Final"
        dense
        :binding.sync="filter.date_end"
        :readOnly="false"
      ></date-picker>
    </div>
    <div class="form-panel__actions">
      <v-btn 
        class="success"
        @click="$emit('submit', filter)"
      >
        <i class="mdi mdi-file-chart-outline pr-1"></i>
        Gerar Relatório
      </v-btn>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/layout/DatePicker";
export default {
  name: "ReportFilters",
  props: {
    creators:Array,
    farms:Array
  },
  components: {
    DatePicker
  },
  data() {
    return {
      filter: {
        farms: [],
        person:{}
      }
    }
  },
  computed: {
    computedCreators() {
      return this.creators.map(e => ({...e, name:e.code_integration + " - " + e.name}))
    },
    likesAllFarms() {
    return this.filter.farms.length === this.farms.length;
    },
    likesSomeFarms() {
      return this.filter.farms.length > 0 && !this.likesAllFarms;
    },
    icon() {
      if (this.likesAllFarms) return "mdi-close-box";
      if (this.likesSomeFarms) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    selectAllFarms() {
      this.$nextTick(() => {
        let all = null;
        if (this.likesAllFarms) {
          this.filter.farms = [];
        } else {
          all = this.farms.map(e => {return e.id});
          this.filter.farms = all.slice();
        }
      });
    }
  }
}
</script>